// src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL:"https://empresas.wandersonelias.com.br",
});

// interceptor para sempre mandar o token (se existir)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
